<template>

    <div class="challenges-scene">

        <template v-if="!backgroundIsTransitioning">

          <div class="challenges-scene__challenges challenges">
              <div class="challenges__heading">{{challengesPageChallengesHeading}}</div>
              <div class="challenges__list" v-if="challenges.length">
                  <template v-for="(challenge, i) in challenges" v-bind:key="i">
                      <router-link :to="'/challenges/'+challenge.id" class="challenges__item" :class="[{'challenges__item--selected': $route.params.challengeId == challenge.id}, 'challenges__item--'+challenge.colorTheme]">
                          <span>{{challenge.challengeName}}</span>
                      </router-link>
                  </template>
              </div>
          </div>

          <div v-if="!selectedCase" class="subbrand-logo"><router-link to="/"><img src="images/subbrand-logo.svg"/></router-link></div>

          <div v-if="!selectedCase" class="corner-logos"><img src="images/corner-logos.png"/></div>

          <div v-if="!selectedCase && !selectedDataLayer" class="challenges-scene__denmark">
            <div class="challenges-scene__denmark-heading">{{challengesPageExperienceDenmarkHeading}}</div>
            <router-link to="/denmark/" class="button button--green">{{challengesPageExperienceDenmarkButtonText}}</router-link>
          </div>
          <div v-if="!selectedCase && !selectedDataLayer" class="challenges-scene__europe">
            <div class="challenges-scene__europe-heading">{{challengesPageExperienceEuropeHeading}}</div>
            <router-link to="/europe/" class="button button--green">{{challengesPageExperienceEuropeButtonText}}</router-link>
          </div>

          <template v-if="!selectedCase">
            <transition name="fade" mode="out-in">
              <div v-if="selectedChallenge" class="data-layer-select" :class="'data-layer-select--'+selectedChallenge.colorTheme" v-bind:key="selectedChallenge.id">
                <div class="data-layer-select__heading">{{challengesPageChallengeDataLayersHeading}}</div>
                <div class="data-layer-select__list">
                  <template v-for="(dataLayer) in dataLayers" v-bind:key="dataLayer.id">
                    <div 
                      v-if="dataLayer.challengeId === parseInt($route.params.challengeId)" 
                      class="data-layer-select__item"
                      :class="{'data-layer-select__item--is-selected': (dataLayer === selectedDataLayer)}"
                      @click="selectDataLayer(dataLayer)">
                        <span>{{dataLayer.dataLayerName}}</span>
                        <div class="data-layer-select__item-marker">
                          <div class="data-layer-select__item-marker-ring"></div>
                        </div>
                        <div class="data-layer-select__item-border"></div>
                      </div>
                  </template>
                </div>
              </div>
            </transition>
          </template>

          <template v-if="selectedDataLayer">
            <div class="data-layer-info" :class="'data-layer-info--'+selectedChallenge.colorTheme" v-bind:key="selectedDataLayer.id">
              <div class="data-layer-info__heading">{{selectedDataLayer.heading}}</div>
              <div class="data-layer-info__text">
                <ScrollBar class="data-layer-info__scroll">
                  <div v-html="selectedDataLayer.text"></div>
                </ScrollBar>
              </div>
              <div class="data-layer-info__close-btn close-button" @click="selectDataLayer(null)"></div>
              <div v-if="selectedDataLayer.subheading" class="data-layer-info__map-info">
                <div class="data-layer-info__map-marker marker">
                  <div class="marker__icon"
                      :class="['marker__icon--datalayer', 'marker__icon--'+selectedChallenge.colorTheme]">
                      <div class="marker__datalayer-icon"></div>
                  </div>
                </div>
                <div><strong>Map shows:</strong> {{selectedDataLayer.subheading}}</div>
              </div>
            </div>
          </template>

          <template v-if="!selectedChallenge">
            <div class="disclaimer" v-html="mapDisclaimer"></div>
          </template>

          <transition name="fade" mode="out-in">
            <CaseOverlay
              v-if="selectedCase"
              :challengeCase="selectedCase"
              :colorTheme="selectedChallenge.colorTheme"
              @close="$router.push('/challenges/'+$route.params.challengeId+'/')">
            </CaseOverlay>
          </transition>

        </template>

    </div>

</template>

<script>
import store from '@/dataStore';
import CaseOverlay from '@/components/CaseOverlay';
import ScrollBar from '@/components/ScrollBar';

export default {
  name: 'Challenges',
  components: {
    CaseOverlay: CaseOverlay,
    ScrollBar: ScrollBar
  },
  data() {
    return {
      isLoading: false,
      challenges: [],
      cases: [],
      dataLayers: [],
      selectedDataLayer: null,
      // NOTE(Mølby): Text strings
      challengesPageChallengesHeading: '',
      challengesPageChallengeDataLayersHeading: '',
      challengesPageExperienceDenmarkHeading: '',
      challengesPageExperienceDenmarkButtonText: '',
      challengesPageExperienceEuropeHeading: '',
      challengesPageExperienceEuropeButtonText: '',
      challengesPageViewCaseLinkText: '',
      mapDisclaimer: '',

      backgroundIsTransitioning: false
    }
  },
  computed:
  {
    selectedChallenge()
    {
      var result = null;

      if (this.$route.params.challengeId)
      {
        this.challenges.forEach((challenge)=>{
          if (challenge.id == this.$route.params.challengeId)
          {
            result = challenge;
          }
        });
      }

      return result;
    },
    selectedCase()
    {
      var result = null;

      if (this.$route.params.caseId)
      {
        this.cases.forEach((challengeCase)=>{
          if (challengeCase.id == this.$route.params.caseId)
          {
            result = challengeCase;
          }
        });
      }

      return result;
    }
  },
  methods:
  {
    selectDataLayer(dataLayer)
    {
      if (this.selectedDataLayer === dataLayer)
      {
        this.selectedDataLayer = null;
      }
      else
      {
        this.selectedDataLayer = dataLayer;
      }
      store.setSelectedDataLayer(this.selectedDataLayer);
    }
  },
  watch: {
		$route() 
    {
      // NOTE(Mølby): Clear datalayer
      store.setSelectedDataLayer(null);
      
      // NOTE(Mølby): Add selected challenge to store if set
      if (this.selectedChallenge)
      {
        store.setSelectedChallenge(this.selectedChallenge);
      }

      if (this.selectedCase)
      {
        store.setGlobeState('normal');
        store.setSelectedCase(this.selectedCase);
      }
      else
      {
        store.setGlobeState('tutorial');
      }
    }
	},
  created()
  {
    this.unsubscribeFromStore = store.subscribe((storeState)=>{
        this.isLoading = storeState.isLoading;
        this.challenges = storeState.challenges;
        this.cases = storeState.cases;
        this.dataLayers = storeState.dataLayers;
        this.selectedDataLayer = storeState.selectedDataLayer;

        this.challengesPageChallengesHeading = storeState.siteInfo.challengesPageChallengesHeading;
        this.challengesPageChallengeDataLayersHeading = storeState.siteInfo.challengesPageChallengeDataLayersHeading;
        this.challengesPageExperienceDenmarkHeading = storeState.siteInfo.challengesPageExperienceDenmarkHeading;
        this.challengesPageExperienceDenmarkButtonText = storeState.siteInfo.challengesPageExperienceDenmarkButtonText;
        this.challengesPageExperienceEuropeHeading = storeState.siteInfo.challengesPageExperienceEuropeHeading;
        this.challengesPageExperienceEuropeButtonText = storeState.siteInfo.challengesPageExperienceEuropeButtonText;
        this.mapDisclaimer = storeState.siteInfo.mapDisclaimer;
        this.backgroundIsTransitioning = storeState.backgroundIsTransitioning;
    });

    store.setGlobeState('tutorial');

    if (!store.state.manifestIsLoaded)
    {
      store.loadManifest()
        .then(()=>
        {
          // NOTE(Mølby): Add selected challenge to store if set
          if (this.selectedChallenge)
          {
            store.setSelectedChallenge(this.selectedChallenge);
          }

          if (this.selectedCase)
          {
            store.setSelectedCase(this.selectedCase);
            store.setGlobeState('normal');
          }
        });
    }
    else
    {
      // NOTE(Mølby): Add selected challenge to store if set
      if (this.selectedChallenge)
      {
        store.setSelectedChallenge(this.selectedChallenge);
      }

      if (this.selectedCase)
      {
        store.setSelectedCase(this.selectedCase);
        store.setGlobeState('normal');
      }
    }
  },
  unmounted()
  {
    store.setSelectedChallenge(null);
    store.setSelectedDataLayer(null);
    this.unsubscribeFromStore();
  }
}
</script>